module.exports = __webpack_public_path__ + "static/media/loader.74caa41d.svg";